var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"bc",class:_vm.classObject,attrs:{"href":_vm.link}},[_c('i',{staticClass:"far fa-copy"}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }